module.exports = __webpack_public_path__ + "img/p4.13c15530.jpg";